import { z } from "zod";

export const FlaggedFeature = z.enum([
  "FigmaImporterV2",
  "DisableImporter",
  "VariablesOrder",
  "TypographyPropsKeepAliases",
  "GradientPropsKeepAliases",
  "ShadowPropsKeepAliases",
  "NonCompatibleTypeChanges",
  "TypographyUseFontStyle",
  "FigmaImporterV3",
  "SparseCheckoutEnabled",
  "NoTagsNoBlobsCheckoutEnabled",

  "PulsarDebugMode",
  "PulsarLogSdkNetwork",
  "PulsarCacheSdk",
  "PulsarPreloadData",
  "PulsarConcurrencyMode",
  "PulsarConcurrency",
  "PulsarProfilerMode",
]);

export const FeatureFlagDefaults = {
  DocumentationIgnoreSnapshotsOnPublish: "route-bff+route-p3" as string,
} as const;
export type FeatureFlagWithDefaults = keyof typeof FeatureFlagDefaults;
export type FeatureFlagDefaultsTypes = {
  [K in FeatureFlagWithDefaults]: (typeof FeatureFlagDefaults)[K];
};

export const FeatureFlagMap = z.record(FlaggedFeature, z.boolean());
export const FeatureFlag = z.object({
  id: z.string(),
  feature: FlaggedFeature,
  createdAt: z.coerce.date(),
  enabled: z.boolean(),
  designSystemId: z.string().optional(),
  data: z.record(z.any()).nullable().optional(),
});

export type FlaggedFeature = z.infer<typeof FlaggedFeature>;
export type FeatureFlagMap = z.infer<typeof FeatureFlagMap>;
export type FeatureFlag = z.infer<typeof FeatureFlag>;
